module.exports = __webpack_public_path__ + "img/L3.be430c6a.png";